module.exports = __webpack_public_path__ + "static/media/reserve.b45d5bca.svg";